import React, { useEffect, useState } from "react"
import "../../../../../App.scss"
import {
  Modal,
  Form,
  Input,
  Row,
  Col,
  message,
  Spin,
  InputNumber,
  Button,
  Checkbox,
  Radio,
} from "antd"
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons"

import SelectTypeSim from "src/components/Dropdown/SelectTypeSim"
import SelectSimType from "src/components/Dropdown/SelectSimType"
import WarehouseService from "src/services/WarehouseService"
import SelectCarrier from "src/components/Dropdown/SelectCarrier"
import { BlockInfoStyle } from "src/pages/ADMIN/HumanResource/styled"
import SelectCustomer from "src/components/Dropdown/SelectCustomer"
import SelectPackage from "src/components/Dropdown/SelectPackage"
import SelectDiscountType from "src/components/Dropdown/SelectDiscountType"
import { SectionTitle, SectionCard } from "../../Warehouse/Modal/styleds"
import SelectCountry from "src/components/Dropdown/SelectCountry"
import PackageDetail from "../component/PackageDetail"
import PackageService from "src/services/PackageService"
import SelectLocalRoaming from "src/components/Dropdown/SelectLocalRoaming"
import OrderB2BService from "src/services/OrderB2BService"
import dayjs from "dayjs"

const ModalCreateOrder = ({
  open,
  onCancel,
  editingRecord,
  isEditMode = false,
  refresh,
  onlyView = false,
  exportEdit,
}) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [initialValues, setInitialValues] = useState(null)
  const [simRows, setSimRows] = useState([0])
  const [dataRows, setDataRows] = useState([0])
  const [totalQuantity, setTotalQuantity] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)
  const [selectedTypes, setSelectedTypes] = useState([])
  const [countryId, setCountryId] = useState(null)
  const [totalDataQuantity, setTotalDataQuantity] = useState(0)
  const [totalAmountAfterDiscount, setTotalAmountAfterDiscount] = useState(0)
  const [discountType, setDiscountType] = useState("percent")
  const [discountValue, setDiscountValue] = useState(0)
  const [note, setNote] = useState(null)
  const [networkId, setNetWorkId] = useState(null)
  const [packageId, setPackageId] = useState(null)
  const [paramsPackageList, setParamsPackageList] = useState({})
  const [supplierID, setSupplierID] = useState(null)
  const [expectedDate, setExpectedDate] = useState(0)

  useEffect(() => {
    calculateTotals(form.getFieldsValue())
  }, [form.getFieldsValue()])
  const calculateTotals = allValues => {
    let totalSimQty = 0
    let totalDataQty = 0
    let totalAmt = 0

    simRows.forEach(index => {
      const qty = Number(allValues[`sim_quantity${index}`]) || 0
      const price = Number(allValues[`sim_unit_price${index}`]) || 0

      totalSimQty += qty
      totalAmt += qty * price
    })
    dataRows.forEach(index => {
      const qty = Number(allValues[`data_quantity${index}`]) || 0
      const price = Number(allValues[`data_unit_price${index}`]) || 0

      totalDataQty += qty
      totalAmt += qty * price
    })

    let amountAfterDiscount = totalAmt
    // console.log(discountValue)
    if (discountType === "percent") {
      amountAfterDiscount = totalAmt - (totalAmt * discountValue) / 100
    } else if (discountType === "fixed") {
      // fixed
      amountAfterDiscount = totalAmt - discountValue
    }

    // Không cho âm
    if (amountAfterDiscount < 0) amountAfterDiscount = 0

    setTotalQuantity(totalSimQty)
    setTotalDataQuantity(totalDataQty)
    setTotalAmount(totalAmt)
    setTotalAmountAfterDiscount(amountAfterDiscount)
  }
  const getSimBasePrice = async (carrier_id, type_sim, sim_type, scope) => {
    try {
      const res = await OrderB2BService.getPriceSim({
        carrier_id,
        type_sim,
        sim_type,
        scope,
      }) // Giả sử API này trả về giá
      return Number(res?.success[0]) || 0
    } catch (err) {
      message.error("Không thể lấy giá SIM")
      return 0
    }
  }
  const handlePriceUpdate = async index => {
    const fields = form.getFieldsValue()
    // const supplierID = fields[`supplier_id`]
    const networkId = fields[`network_id${index}`]
    const typeSim = fields[`type_sim`]
    const simType = fields[`sim_type${index}`]
    const packageId = fields[`package_id${index}`]
    const scope = fields[`scope${index}`]

    let simPrice = 0
    let packagePrice = 0

    // Chỉ khi đủ thông tin thì mới tính
    if (typeSim && typeSim && simType && scope) {
      simPrice = await getSimBasePrice(networkId, typeSim, simType, scope)
      // await getPackageList(networkId, typeSim, simType)
      setParamsPackageList({ networkId, typeSim, simType, scope })
    }

    if (packageId) {
      const res = await PackageService.packageDetailLeader(packageId)
      packagePrice = Number(res?.success?.price_sell) || 0
      const packageExpectedDate = res?.success?.package_type
      if (Number(packageExpectedDate) > expectedDate) {
        setExpectedDate(packageExpectedDate)
      }
    }

    const totalPrice = Number(packagePrice)
      ? Number(packagePrice)
      : Number(simPrice)
    calculateTotals(form.getFieldsValue())
    form.setFieldsValue({
      [`sim_unit_price${index}`]: totalPrice,
    })
  }
  useEffect(() => {
    if (initialValues && simRows.length > 0 && dataRows.length > 0) {
      // console.log(initialValues, "initialValues")
      form.setFieldsValue(initialValues)
    }
  }, [selectedTypes, initialValues])
  useEffect(() => {
    if (open) {
      if (isEditMode && editingRecord) {
        fetchDataDetail()
      } else {
        // Reset form nếu không ở chế độ chỉnh sửa
        form.resetFields()
        setSimRows([0])
        setTotalQuantity(0)
        setTotalAmount(0)
      }
    }
  }, [isEditMode])
  const fetchDataDetail = async () => {
    setLoading(true)
    try {
      // console.log("fetch detail", editingRecord)
      if (isEditMode && editingRecord?.ID) {
        const response = await WarehouseService.detailOrder(editingRecord.ID)
        const detail = response?.success || {}
        setNote(detail.note || null)
        const types = []
        if (detail?.sim_details?.length > 0) {
          types.push("sim")

          const hasPackage = detail.sim_details.some(item => item.package_id)
          if (hasPackage) {
            types.push("data")
          }
        }

        if (detail?.data_details?.length > 0) {
          types.push("data")
        }
        setSelectedTypes(types)
        const initialValues = {
          export_code: detail.export_code,
          customer_id: Number(detail.customer_id),
          country_id: Number(detail.country_id),
          discount_type: detail.discount_type,
          discount: Number(detail.discount),
          note: detail.note,
          ...detail?.data_details?.reduce((acc, data, index) => {
            acc[`data_network_id${index}`] = Number(data.network_id)
            acc[`data_supplier_id${index}`] = Number(data.supplier_id)
            acc[`data_quantity${index}`] = data.data_quantity
            acc[`data_unit_price${index}`] = data.data_unit_price
            return acc
          }, {}),
          ...detail?.sim_details?.reduce((acc, sim, index) => {
            acc[`network_id${index}`] = Number(sim.network_id)
            acc[`supplier_id${index}`] = Number(sim.supplier_id)
            acc[`type_sim`] = sim.type_sim
            acc[`sim_type${index}`] = sim.sim_type
            acc[`scope${index}`] = sim.scope
            acc[`package_id${index}`] = sim.package_id || ""
            acc[`sim_unit_price${index}`] = sim.sim_unit_price
            acc[`sim_quantity${index}`] = sim.sim_quantity
            return acc
          }, {}),
        }
        setCountryId(Number(detail.country_id))
        setInitialValues(initialValues)
        setSimRows(
          Array.from({ length: detail?.sim_details?.length }, (_, i) => i),
        )
        setDataRows(
          Array.from({ length: detail?.data_details?.length }, (_, i) => i),
        )
      }
    } catch (error) {
      console.error("Lỗi khi lấy chi tiết data:", error)
    } finally {
      setLoading(false)
    }
  }

  const handleCreateOrUpdateSim = async values => {
    if (selectedTypes.length === 0) {
      message.error("Vui lòng chọn ít nhất một loại đơn hàng")
      return
    }
    setLoading(true)
    try {
      const simsData = simRows
        .map((_, index) => ({
          supplier_id: values[`supplier_id${index}`],
          network_id: values[`network_id${index}`],
          type_sim: values[`type_sim`],
          sim_type: values[`sim_type${index}`],
          scope: values[`scope${index}`],
          sim_unit_price: values[`sim_unit_price${index}`],
          package_id: values[`package_id${index}`],
          sim_quantity: values[`sim_quantity${index}`],
        }))
        .filter(item =>
          Object.values(item).some(
            value =>
              value !== undefined &&
              value !== null &&
              value !== "" &&
              !(typeof value === "number" && isNaN(value)),
          ),
        )
      const datas = dataRows
        .map((_, index) => ({
          network_id: values[`data_network_id${index}`],
          supplier_id: values[`data_supplier_id${index}`],
          data_quantity: values[`data_quantity${index}`],
          data_unit_price: values[`data_unit_price${index}`],
        }))
        .filter(item =>
          Object.values(item).some(
            value =>
              value !== undefined &&
              value !== null &&
              value !== "" &&
              !(typeof value === "number" && isNaN(value)),
          ),
        )

      const payload = {
        customer_id: values.customer_id,
        sim_unit_price: totalAmount,
        discount: values.discount,
        export_code: values.export_code,
        discount_type: values.discount_type,
        country_id: values.country_id,
        total_amount: totalAmount,
        total_discount: totalAmountAfterDiscount,
        expected_delivery_date: dayjs()
          .add(expectedDate, "day")
          .format("YYYY-MM-DD"),
        sim_type: simsData[0].type_sim === "usim" ? 1 : 2,
        sim: simsData,
        data: datas,
      }

      const exportPayload = {
        discount: values.discount,
        discount_type: values.discount_type,
        total_discount: totalAmountAfterDiscount,
      }

      if (isEditMode && editingRecord?.ID) {
        if (exportEdit) {
          await WarehouseService.updateExportWarehouse(
            editingRecord.ID,
            exportPayload,
          )
          message.success("Cập nhật phiếu xuất kho thành công")
          refresh(prev => !prev)
        } else {
          await WarehouseService.updateOrder(editingRecord.ID, payload)
          message.success("Cập nhật đơn hàng thành công")
          refresh(prev => !prev)
        }
      } else {
        await WarehouseService.createOrder(payload)
        message.success("Tạo đơn hàng thành công")
        refresh(prev => !prev)
      }
      // form.resetFields()
      onCancel()
    } catch (error) {
      console.error("Lỗi khi xử lý đơn hàng", error)
      message.error(error.response?.data?.message || "Xử lý đơn hàng thất bại")
    } finally {
      setLoading(false)
    }
  }

  const addSimRow = () => {
    setSimRows([...simRows, simRows.length])
  }
  const removeSimRow = indexToRemove => {
    // console.log(indexToRemove)
    if (simRows.length <= 1) return

    const newSimRows = simRows.filter((_, i) => i !== indexToRemove)
    setSimRows(newSimRows)

    // Cập nhật các trường trong form
    const currentValues = form.getFieldsValue()
    const keysToRemove = Object.keys(currentValues).filter(
      key =>
        key.includes(`_${indexToRemove}`) || key.includes(`${indexToRemove}`),
    )

    // Reset các trường đã xóa
    form.resetFields(keysToRemove)

    // Cập nhật lại tổng số lượng và tổng tiền
    calculateTotals(form.getFieldsValue())
  }

  const addDataRow = () => {
    setDataRows([...dataRows, dataRows.length])
  }
  const removeDataRow = indexToRemove => {
    if (dataRows.length <= 1) return

    const newDataRows = dataRows.filter((_, i) => i !== indexToRemove)
    setDataRows(newDataRows)

    // Cập nhật các trường trong form
    const currentValues = form.getFieldsValue()
    const keysToRemove = Object.keys(currentValues).filter(
      key =>
        key.includes(`_${indexToRemove}`) || key.includes(`${indexToRemove}`),
    )

    // Reset các trường đã xóa
    form.resetFields(keysToRemove)

    // Cập nhật lại tổng số lượng và tổng tiền
    calculateTotals(form.getFieldsValue())
  }
  useEffect(() => {
    if (open) {
      if (isEditMode && editingRecord) {
        setInitialValues({
          ...editingRecord,
        })
        setDiscountValue(Number(editingRecord.discount))
        setDiscountType(editingRecord.discount_type)
        if (editingRecord.sims && editingRecord.sims.length > 0) {
          setSimRows(
            Array.from({ length: editingRecord.sims.length }, (_, i) => i),
          )
          // Tính toán tổng số lượng và tổng tiền khi edit
          let qty = 0
          let amt = 0
          editingRecord.sims.forEach(sim => {
            qty += Number(sim.sim_quantity) || 0
            amt +=
              (Number(sim.sim_quantity) || 0) *
              (Number(sim.sim_unit_price) || 0)
          })
          setTotalQuantity(qty)
          setTotalAmount(amt)
        }
      } else {
        setInitialValues(null)
        form.resetFields()
        setSimRows([0]) // Reset về 1 hàng khi mở modal mới
        setTotalQuantity(0)
        setTotalAmount(0)
      }
    }
  }, [isEditMode])

  return (
    <Modal
      open={open}
      title={
        onlyView
          ? "Xem thông tin đơn hàng"
          : isEditMode
          ? "Chỉnh sửa đơn hàng"
          : "Tạo đơn hàng"
      }
      onCancel={() => {
        form.resetFields()
        setTotalQuantity(0)
        setTotalAmount(0)
        onCancel()
      }}
      onOk={() => form?.submit()}
      okText={isEditMode ? "Cập nhật" : "Tạo"}
      cancelText="Hủy"
      width={1400}
      confirmLoading={loading}
      destroyOnClose={true}
      footer={onlyView ? null : undefined}
    >
      <Spin spinning={loading}>
        <Form.Item label="Loại đơn hàng">
          <Radio.Group
            options={[
              { label: "Sim", value: "sim" },
              { label: "Data", value: "data" },
            ]}
            value={selectedTypes?.[0]} // vì Radio chỉ chọn 1 nên lấy phần tử đầu
            onChange={e => {
              const value = e.target.value
              setSelectedTypes([value]) // vẫn lưu dưới dạng array để giữ logic cũ
              setPackageId(null)

              if (value !== "data") {
                const resetFields = {}

                simRows.forEach((_, index) => {
                  resetFields[`network_id${index}`] = undefined
                  resetFields[`sim_type${index}`] = undefined
                  // resetFields[`type_sim`] = undefined
                  resetFields[`package_id${index}`] = undefined
                  resetFields[`sim_unit_price${index}`] = undefined
                  resetFields[`sim_quantity${index}`] = undefined
                  resetFields[`scope${index}`] = undefined
                })
                form.setFieldsValue(resetFields)
              }
            }}
            disabled={onlyView || exportEdit}
          />
        </Form.Item>

        <Form
          layout="vertical"
          form={form}
          onFinish={handleCreateOrUpdateSim}
          // initialValues={initialValues}
          onValuesChange={calculateTotals}
        >
          {/* Phần khách hàng chung */}
          <div style={{ position: "relative" }}>
            {packageId && (
              <div
                style={{
                  position: "absolute",
                  top: -60,
                  right: 80,
                  width: "320px",
                  height: "120px",
                  zIndex: 1200,
                }}
              >
                <PackageDetail id={packageId} />
              </div>
            )}
            <Row gutter={16}>
              <Col span={4}>
                <Form.Item
                  name="customer_id"
                  label="Khách hàng"
                  rules={[
                    { required: true, message: "Vui lòng chọn khách hàng" },
                  ]}
                >
                  <SelectCustomer
                    disabled={onlyView || exportEdit}
                    type={"LEADER"}
                    placeholder={"Chọn khách hàng"}
                    level={0}
                  />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  name={`discount_type`}
                  label="Loại chiết khấu"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng chọn loại chiết khấu",
                    },
                  ]}
                >
                  <SelectDiscountType
                    disabled={onlyView}
                    value={discountType}
                    onChange={value => {
                      setDiscountType(value)
                      form.setFieldsValue({ discount: "" })
                      setDiscountValue(0)
                      form.validateFields(["discount"])
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  name={`discount`}
                  label="Chiết khấu"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập chiết khấu",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const discountType = getFieldValue("discount_type")
                        if (value < 0) {
                          return Promise.reject(
                            "Chiết khấu không được nhỏ hơn 0",
                          )
                        }
                        if (discountType === "percent" && value > 100) {
                          return Promise.reject(
                            "Giá trị % không được vượt quá 100",
                          )
                        }
                        return Promise.resolve()
                      },
                    }),
                  ]}
                >
                  <InputNumber
                    placeholder="Chiết khấu "
                    style={{ width: "100%" }}
                    min={0}
                    disabled={onlyView}
                    // value={discountValue}
                    parser={value => value.replace(/\D/g, "")}
                    onChange={value => {
                      setDiscountValue(value ?? null)
                    }}
                    onKeyPress={e => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault() // chặn mọi phím không phải số
                      }
                    }}
                  />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Row gutter={16}>
                  {selectedTypes.includes("sim") && (
                    <Col span={4} style={{ marginTop: 38 }}>
                      <strong>Tổng số lượng sim: </strong> {totalQuantity}
                    </Col>
                  )}
                  {selectedTypes.includes("data") &&
                    !selectedTypes.includes("sim") && (
                      <Col span={5} style={{ marginTop: 38 }}>
                        <strong>Tổng dung lượng data: </strong>
                        {totalDataQuantity}
                        GB
                      </Col>
                    )}
                  <Col span={6} style={{ marginTop: 38 }}>
                    <strong>Tổng tiền đơn hàng: </strong>
                    {totalAmount.toLocaleString()}
                    {/* VNĐ */}
                  </Col>
                  <Col span={6} style={{ marginTop: 38 }}>
                    <strong>Tổng tiền sau chiết khấu: </strong>
                    {totalAmountAfterDiscount.toLocaleString()}
                    {/* VNĐ */}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          {selectedTypes.includes("sim") && (
            <SectionCard>
              <SectionTitle>Thông tin đơn hàng SIM</SectionTitle>
              <BlockInfoStyle>
                <div style={{ marginBottom: 16 }}>
                  <Row gutter={16}>
                    <Col span={3}>
                      <strong>Nhà mạng</strong>
                    </Col>
                    <Col span={3}>
                      <strong>Loại sim</strong>
                    </Col>
                    <Col span={3}>
                      <strong>Local/Roaming</strong>
                    </Col>

                    <Col span={3}>
                      <strong>Loại hình sim</strong>
                    </Col>
                    <Col span={4}>
                      <strong>Gói cước</strong>
                    </Col>
                    <Col span={3}>
                      <strong>Đơn giá (VNĐ)</strong>
                    </Col>
                    <Col span={2}>
                      <strong>Số lượng</strong>
                    </Col>
                    <Col span={3}>
                      <strong>Tổng tiền:</strong>
                    </Col>
                  </Row>
                </div>

                {simRows.map((row, index) => (
                  <div
                    key={index}
                    style={{ position: "relative", marginBottom: 16 }}
                  >
                    {index > 0 && !onlyView && !exportEdit && (
                      <Button
                        type="text"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => removeSimRow(index)}
                        style={{
                          position: "absolute",
                          right: 10,
                          top: 0,
                          zIndex: 9999,
                        }}
                      />
                    )}

                    <Row gutter={16}>
                      <Col span={3}>
                        <Form.Item
                          name={`network_id${index}`}
                          // label="Nhà mạng"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng chọn nhà mạng",
                            },
                          ]}
                        >
                          <SelectCarrier
                            disabled={onlyView || exportEdit}
                            countryId={countryId}
                            onChange={value => {
                              setNetWorkId(value)
                              setPackageId(null)
                              form.setFieldsValue({
                                [`package_id${index}`]: undefined,
                                // [`sim_unit_price${index}`]: undefined,
                                [`sim_quantity${index}`]: undefined,
                                // [`scope${index}`]: undefined,
                              })
                              handlePriceUpdate(index)
                            }}
                            isView={onlyView || isEditMode}
                          />
                        </Form.Item>
                        <Form.Item hidden name={`supplier_id${index}`}>
                          <Input hidden />
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        <Form.Item
                          name={`type_sim`}
                          // label="Loại sim"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng chọn loại Sim",
                            },
                          ]}
                        >
                          <SelectTypeSim
                            disabled={onlyView || exportEdit || index > 0}
                            onChange={val => {
                              handlePriceUpdate(index)
                              form.setFieldsValue({
                                [`package_id${index}`]: null,
                              })
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        <Form.Item
                          name={`scope${index}`}
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng chọn Local/Roaminng",
                            },
                          ]}
                        >
                          <SelectLocalRoaming
                            disabled={onlyView || exportEdit}
                            onChange={() => {
                              handlePriceUpdate(index)
                              form.setFieldsValue({
                                [`package_id${index}`]: null,
                              })
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={3}>
                        <Form.Item
                          name={`sim_type${index}`}
                          // label="Loại hình sim"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng chọn loại hình sim",
                            },
                          ]}
                        >
                          <SelectSimType
                            disabled={onlyView || exportEdit}
                            onChange={() => {
                              handlePriceUpdate(index)
                              form.setFieldsValue({
                                [`package_id${index}`]: null,
                              })
                            }}
                          />
                        </Form.Item>
                      </Col>
                      {/* {selectedTypes.includes("data") &&
                        selectedTypes.includes("sim") && ( */}
                      <Col span={4}>
                        <Form.Item
                          name={`package_id${index}`}
                          // label="Gói cước"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng chọn gói cước",
                            },
                          ]}
                        >
                          <SelectPackage
                            disabled={onlyView || exportEdit}
                            listAll={onlyView || exportEdit || editingRecord}
                            networkId={networkId}
                            paramsPackageList={paramsPackageList}
                            setSupplierID={setSupplierID}
                            isView={onlyView || isEditMode}
                            onChange={async (value, option) => {
                              form.setFieldsValue({
                                [`sim_quantity${index}`]: undefined,
                                [`supplier_id${index}`]: option?.supplier_id,
                              })
                              setPackageId(value)
                              await handlePriceUpdate(index)
                            }}
                          />
                        </Form.Item>
                      </Col>
                      {/* )} */}
                      <Col span={3}>
                        <Form.Item
                          name={`sim_unit_price${index}`}
                          // label="Đơn giá (VNĐ)"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng nhập đơn giá",
                            },
                            {
                              validator: (_, value) => {
                                if (value >= 0) {
                                  return Promise.resolve()
                                }
                                return Promise.reject(
                                  "Đơn giá phải lớn hơn hoặc bằng 0",
                                )
                              },
                            },
                          ]}
                        >
                          <InputNumber
                            placeholder="Nhập đơn giá"
                            style={{ width: "100%" }}
                            min={0}
                            formatter={value =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }
                            parser={value => value.replace(/\D/g, "")}
                            disabled={onlyView || exportEdit}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={2}>
                        <Form.Item
                          name={`sim_quantity${index}`}
                          // label="Số lượng"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng nhập số lượng",
                            },
                            {
                              validator: (_, value) => {
                                if (value <= 0) {
                                  return Promise.reject(
                                    "Số lượng phải lớn hơn 0",
                                  )
                                }
                                return Promise.resolve()
                              },
                            },
                          ]}
                        >
                          <InputNumber
                            placeholder="Nhập số lượng"
                            style={{ width: "100%" }}
                            min={1}
                            disabled={onlyView || exportEdit}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={3} style={{ marginTop: 0 }}>
                        <strong>
                          {(
                            (form.getFieldValue(`sim_quantity${index}`) || 0) *
                            (form.getFieldValue(`sim_unit_price${index}`) || 0)
                          ).toLocaleString()}
                        </strong>
                      </Col>
                    </Row>
                  </div>
                ))}
              </BlockInfoStyle>
              {!onlyView && !exportEdit && (
                <Row>
                  <Col span={3}>
                    <Button
                      type="dashed"
                      onClick={addSimRow}
                      block
                      icon={<PlusOutlined />}
                    >
                      Thêm sim
                    </Button>
                  </Col>
                </Row>
              )}
            </SectionCard>
          )}
          {selectedTypes.includes("data") && !selectedTypes.includes("sim") && (
            <SectionCard>
              <SectionTitle>Thông tin đơn hàng DATA</SectionTitle>
              <BlockInfoStyle>
                <div style={{ marginBottom: 16 }}>
                  <Row gutter={16}>
                    <Col span={5}>
                      <strong>Nhà mạng</strong>
                    </Col>
                    <Col span={5}>
                      <strong>Dung lượng Data (GB)</strong>
                    </Col>
                    <Col span={5}>
                      <strong>Đơn giá</strong>
                    </Col>
                    <Col span={4}>
                      <strong>Tổng tiền:</strong>
                    </Col>
                  </Row>
                </div>

                {dataRows.map((row, index) => (
                  <div
                    key={index}
                    style={{ position: "relative", marginBottom: 16 }}
                  >
                    {index > 0 && !onlyView && !exportEdit && (
                      <Button
                        type="text"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => removeDataRow(index)}
                        style={{
                          position: "absolute",
                          right: 10,
                          top: 0,
                          zIndex: 9999,
                        }}
                      />
                    )}

                    <Row gutter={16}>
                      <Col span={5}>
                        <Form.Item
                          name={`data_network_id${index}`}
                          // label="Nhà mạng"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng chọn nhà mạng",
                            },
                          ]}
                        >
                          <SelectCarrier
                            disabled={onlyView || exportEdit}
                            countryId={countryId}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={5}>
                        <Form.Item
                          name={`data_quantity${index}`}
                          // label="Số lượng"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng nhập dung lượng",
                            },
                            {
                              validator: (_, value) => {
                                if (value <= 0) {
                                  return Promise.reject(
                                    "Số lượng phải lớn hơn 0",
                                  )
                                }
                                return Promise.resolve()
                              },
                            },
                          ]}
                        >
                          <InputNumber
                            placeholder="Nhập dung lượng Data"
                            style={{ width: "100%" }}
                            min={1}
                            disabled={onlyView || exportEdit}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={5}>
                        <Form.Item
                          name={`data_unit_price${index}`}
                          // label="Đơn giá (VNĐ)"
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng nhập đơn giá",
                            },
                            {
                              validator: (_, value) => {
                                if (value >= 0) {
                                  return Promise.resolve()
                                }
                                return Promise.reject(
                                  "Đơn giá phải lớn hơn hoặc bằng 0",
                                )
                              },
                            },
                          ]}
                        >
                          <InputNumber
                            placeholder="Nhập đơn giá"
                            style={{ width: "100%" }}
                            min={0}
                            formatter={value =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }
                            parser={value => value.replace(/\D/g, "")}
                            disabled={onlyView || exportEdit}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={4} style={{ marginTop: 0 }}>
                        <strong>
                          {(
                            (form.getFieldValue(`data_quantity${index}`) || 0) *
                            (form.getFieldValue(`data_unit_price${index}`) || 0)
                          ).toLocaleString()}
                          VNĐ
                        </strong>
                      </Col>
                    </Row>
                  </div>
                ))}
              </BlockInfoStyle>

              {/* Nút thêm hàng */}
              {!onlyView && !exportEdit && (
                <Row>
                  <Col span={5}>
                    <Button
                      type="dashed"
                      onClick={addDataRow}
                      block
                      icon={<PlusOutlined />}
                    >
                      Thêm
                    </Button>
                  </Col>
                </Row>
              )}
            </SectionCard>
          )}
          {note && (
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item name="note" label="Ghi chú">
                  <Input.TextArea placeholder="Ghi chú" disabled />
                </Form.Item>
              </Col>
            </Row>
          )}
        </Form>
      </Spin>
    </Modal>
  )
}

export default ModalCreateOrder
